<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">Liquidacion Pedido</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--6">
      <div class="row justify-content-center">
        <div class="col-12 card-wrapper">
          <div class="card mb-4">
            <div class="card-header">
              <div class="card-body">
                <order-info :order="order" />

                <div></div>
              </div>
              <hr />
              <div class="card-body">
                <commission-by-items v-if="order" :order="order" :dollar-quotation="dollarQuotation" />
              </div>
              <div class="card-body">
                <payment-by-months v-if="order" :order="order" />
              </div>
            </div>
          </div>

          <collapse v-if="!distributorCommission.isLoading" :active-index="0">
            <collapse-item body-classes="p-0 m-0">
              <template slot="title">
                <h3 class="mb-0">
                  <span>Comisión del Distribuidor</span>
                </h3>
              </template>

              <commissions-table v-bind="distributorCommission" />
            </collapse-item>
          </collapse>

          <collapse v-if="!sellerCommission.isLoading" :active-index="0">
            <collapse-item body-classes="p-0 m-0">
              <template slot="title">
                <h3 class="mb-0">
                  <span>Comisión del Asesor Técnico</span>
                </h3>
              </template>

              <commissions-table v-bind="sellerCommission" />
            </collapse-item>
          </collapse>

          <div class="row mt-4 mb-3 text-right">
            <div class="col-12">
              <base-button v-if="canLiquidate" type="success" @click="generateLiquidation">
                <i class="fas fa-dollar-sign mr-1"></i><span>Generar Liquidación</span>
              </base-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CommissionsTable from './List/CommissionsTable';
import OrderInfo from './List/OrderInfo.vue';
import PaymentByMonths from './List/PaymentByMonths.vue';
import CommissionByItems from './List/CommissionByItems.vue';

import Collapse from '@/components/Collapse/Collapse';
import CollapseItem from '@/components/Collapse/CollapseItem';
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import swal from 'sweetalert2';
import OrdersService from '@/services/resources/orders.service';

export default {
  name: 'Liquidate',
  components: {
    CommissionsTable,
    Collapse,
    CollapseItem,
    RouteBreadCrumb,
    OrderInfo,
    PaymentByMonths,
    CommissionByItems,
  },

  data() {
    return {
      order: null,

      sellerCommission: {
        items: [],
        usdTotal: 0,
        lastIndex: 0,
        isLoading: false,
      },

      distributorCommission: {
        items: [],
        usdTotal: 0,
        lastIndex: 0,
        isLoading: false,
      },
    };
  },

  computed: {
    canLiquidate() {
      return this.order ? this.order.state.name === OrdersService._STATE_TO_LIQUIDATE : false;
    },

    dollarQuotation() {
      const totals = this.distributorCommission.items.at(-1);

      if (!totals) {
        return 0;
      }

      return totals.commissionARS / totals.commissionUSD;
    },
  },

  mounted() {
    this.orderId = this.$route.params.orderId;
    this.fetchOrder(this.orderId);
    this.fetchCommissionsBySeller();
    this.fetchCommissionsByDistributor();
  },

  methods: {
    fetchCommissionsBySeller() {
      const params = { for_seller: 1 };
      this.sellerCommission.isLoading = true;

      this.$services
        .resource('orders')
        .getLiquidation(this.orderId, params)
        .then((res) => res.data)
        .then((rows) => {
          this.sellerCommission.items = rows;
          this.sellerCommission.usdTotal = Number(rows.at(-1).commissionUSD);
          this.sellerCommission.lastIndex = rows.length - 1;
        })
        .finally(() => {
          this.sellerCommission.isLoading = false;
        });
    },

    fetchCommissionsByDistributor() {
      const params = { for_seller: 0 };
      this.distributorCommission.isLoading = true;

      this.$services
        .resource('orders')
        .getLiquidation(this.orderId, params)
        .then((res) => res.data)
        .then((rows) => {
          this.distributorCommission.items = rows;
          this.distributorCommission.usdTotal = Number(rows.at(-1).commissionUSD);
          this.distributorCommission.lastIndex = rows.length - 1;
        })
        .finally(() => {
          this.distributorCommission.isLoading = false;
        });
    },

    generateLiquidation() {
      this.$services
        .resource('orders')
        .generateLiquidation(this.orderId)
        .then(() => {
          swal({
            title: 'Listo!',
            text: 'Liquidación realizada con éxito.',
            buttonsStyling: false,
            confirmButtonClass: 'btn btn-success',
            type: 'success',
          }).then(() => {
            this.$router.go(-1);
          });
        })
        .catch((error) => {
          this.$error(error.response.data.message);
        });
    },

    fetchOrder() {
      const params = {
        include: ['producer.distributor.seller', 'items.article', 'state'],
        append: ['total', 'total-in-pesos'],
      };

      this.$services
        .resource('orders')
        .show(this.orderId, params)
        .then((res) => res.data.data)
        .then((order) => (this.order = order));
    },
  },
};
</script>
